import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import classes from './LoginPage.module.css';
import { requestOtpApi, checkUserApi } from '../http/http';
import TermsModal from "./TermsModal";
const { v4: uuidv4 } = require('uuid');
const plans = [
    { id: "daily", name: "GamePlex_Daily", price: "3 MVR" , value:"3"},
    { id: "weekly", name: "GamePlex_Weekly", price: "10 MVR" ,value:"10"},
    { id: "monthly", name: "GamePlex_Monthly", price: "35 MVR" ,value:"35"},
];

const LoginPage = () => {
    const [phone, setPhone] = useState('');
    const [mode, setMode] = useState('subscribe'); // 🔥 toggle state
    const [selectedPlan, setSelectedPlan] = useState(plans[0].id);
    const [selectedPland, setSelectedPland] = useState(plans[0]);
    const [showTerms, setShowTerms] = useState(false);
    const [diasble, setdiasble] = useState(false);
    const navigate = useNavigate();
    const url=new URL(window.location);

    const [searchParams , setSearchParams]=useSearchParams();

    const [extId,setExtId]=useState(null);

    useEffect(()=>{
        if(searchParams.get('ext_id')){
            setExtId(searchParams.get('ext_id'))
        }
        else{
            setSearchParams({ext_id:uuidv4()});
        }
    },[searchParams])

    console.log(extId,'extId');
    // url.searchParams.set("ext_ref",uuidv4())

    const handleSubscribe = async (e) => {
        e.preventDefault();

        try {
            console.log(selectedPland)
            const res = await requestOtpApi(phone, selectedPland.name);

            if (res.data.data.statusCode === "200") {
                navigate(`/otp?ext_id=${extId}`, {
                    state: {
                        phone,
                        accessToken: res.data.data.accessToken,selectedPlan:selectedPland,price:res.data.data.price,
                    }
                });
            } else if (res.data.data.exist === true) {
                navigate('/');
                localStorage.setItem("jwt",res.data.data.jwt)
            } else {
                alert(res.data.data.statusDescription + "to send otp");
            }
        } catch (err) {
            alert(err);
            console.log(err);
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault()
        // if (!selectedPlan) {
        //     alert("Please select a plan");

        //     return;
        // }
        try {
            const res = await checkUserApi(phone);
            console.log(res.data);
            if (res.data.data.exist === true) {
                localStorage.setItem("jwt",res.data.data.jwt)
                navigate('/');
            } else {
                alert('User does not exist')
            }


        } catch (err) {
            alert(err);
            console.log(err);

        }

        console.log("Selected Plan:", selectedPlan);
        // 👉 call API here later
    };

    return (
        <div className={classes.page_wrapper}>
            <TermsModal
                show={showTerms}
                onClose={() => setShowTerms(false)}
            />
            <div className={classes.bg_blob_1}></div>
            <div className={classes.bg_blob_2}></div>

            <div className={classes.card}>
                {/* Logo */}
                <div className={classes.logo_area}>
                    <div className={classes.logo_icon_wrap}>
                        <img
                            src="/assets/images/logo.png"
                            alt="GamePlex logo"
                            className={classes.logo_icon}
                        />
                    </div>
                    <p className={classes.logo_text}>
                        Game<span>Plex</span>
                    </p>
                </div>

                {/* 🔁 TOGGLE BUTTONS */}
                <div className={classes.toggle_wrap}>
                    <button disabled={diasble}
                        className={mode === 'login' ? classes.active_toggle : ''}
                        onClick={() => setMode('login')}
                    >
                        Login
                    </button>
                    <button   disabled={diasble}
                        className={mode === 'subscribe' ? classes.active_toggle : ''}
                        onClick={() => setMode('subscribe')}
                    >
                        Subscribe
                    </button>
                </div>

                {/* ================= LOGIN ================= */}
                {mode === 'login' && (
                    <>
                        <div className={classes.heading_area}>
                            <h1 className={classes.title}>Welcome back</h1>
                            <p className={classes.subtitle}>
                                Sign in with your mobile number
                            </p>
                        </div>

                        <form className={classes.form} onSubmit={handleLogin}>
                            <span className={classes.field_label}>Mobile Number</span>

                            <div className={classes.input_group}>
                                <span className={classes.input_prefix}>+960</span>
                                <input
                                    className={classes.input}
                                    type="tel"
                                    placeholder="7X XX XXXX"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    maxLength={7}
                                />
                            </div>

                            <button type="submit" className={classes.submit_btn}>
                                Login
                            </button>
                        </form>
                    </>
                )}

                {/* ================= SUBSCRIBE ================= */}
                {mode === 'subscribe' && (
                    <>
                        <div className={classes.form}>
                            <span className={classes.field_label}>Mobile Number</span>

                            <div className={classes.input_group}>
                                <span className={classes.input_prefix}>+960</span>
                                <input
                                    className={classes.input}
                                    type="tel"
                                    placeholder="7X XX XXXX"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    maxLength={7}
                                />
                            </div>
                        </div>

                        <div className={classes.heading_area}>
                            <h1 className={classes.title}>Choose Plan</h1>
                            <p className={classes.subtitle}>
                                Select your GamePlex package
                            </p>
                        </div>

                        <div className={classes.plan_list}>
                            {plans.map((plan) => (
                                <div
                                    key={plan.id}
                                    className={`${classes.plan_item} ${selectedPlan === plan.id ? classes.plan_active : ''
                                        }`}
                                    onClick={() => {
                                        setSelectedPland(plan)
                                        setSelectedPlan(plan.id)}}
                                >
                                    <div>
                                        <h3>{plan.name}</h3>
                                    </div>
                                    <div className={classes.plan_price}>
                                        {plan.price}
                                    </div>
                                </div>
                            ))}
                        </div>


                        <button
                            className={classes.submit_btn}
                            onClick={handleSubscribe}
                        >
                            Continue
                        </button>
                    </>
                )}

                {/* Footer */}
                <p className={classes.terms_text}>
                    By continuing, you agree to our{' '}
                    <span
                        className={classes.terms_link}
                        onClick={() => setShowTerms(true)}
                    >
                        Terms and Conditions
                    </span>
                </p>
            </div>
        </div>
    );
};

export default LoginPage;